import { Col, Row } from 'antd'
import CalenderStyled from 'components/CalenderStyled/CalenderStyled'
import Drawer from 'components/Drawer'
import {
  addDays,
  addWeeks,
  endOfWeek,
  format,
  startOfWeek,
  subDays,
  subWeeks,
} from 'date-fns'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import ConfirmationModal from '../../components/ConfirmationModal'
import SuccessModal from '../../components/SuccessModal'
import Debounce, { formatDateWithOrdinal } from '../../utils/commonFunction'
import Header from './Header'
import { MainWrapper, MiniCalWidth } from './Header/style'
import {
  DynamicText,
  StatusButton,
} from './ListView/List/partials/Upcoming/style'
import EventDetails from './Partials/EventDetails'
import EventPreview from './Preview/Partials/Drawer/EventPreview'
// import { DynamicText, StatusButton } from './WeekView/Style/style'

export const categoryBasedStyle = status => {
  switch (status) {
    case 'EXHIBITION':
      return {
        color: '#ffffff',
        bgColor: 'rgb(89 95 51 / 20%)',
        borderColor: '#595F33',
        status: 'Exhibition',
      }
    case 'ACTIVITY_EVENT':
      return {
        color: '#ffffff',
        bgColor: 'rgba(2, 69, 122, 0.2)',
        borderColor: '#02457A',
        status: 'Activity/Event',
      }
    case 'SPORTS_EVENT':
      return {
        color: '#ffffff',
        bgColor: 'rgb(19 89 63 / 20%)',
        borderColor: '#13593F',
        status: 'Sports/Event',
      }
    case 'CAMPAIGN':
      return {
        color: '#ffffff',
        bgColor: 'rgba(223, 147, 255, 0.25)',
        borderColor: '#4C1D91',
        status: 'Campaign',
      }
    case 'WORKSHOP':
      return {
        color: '#000000',
        bgColor: 'rgb(114 176 111 / 20%)',
        borderColor: '#72B06F',
        status: 'Workshop',
      }
    case 'HACKATHON':
      return {
        color: '#000000',
        bgColor: 'rgb(49 170 181 / 20%)',
        borderColor: '#31AAB5',
        status: 'Hackathon',
      }
    case 'PANEL_DISCUSSION':
      return {
        color: '#ffffff',
        bgColor: 'rgb(242 92 5 / 20%)',
        borderColor: '#F25C05',
        status: 'Panel Discussion',
      }
    case 'CONFERENCE':
      return {
        color: '#000000',
        bgColor: 'rgb(242 159 5 / 25%)',
        borderColor: '#F29F05',
        status: 'Conference',
      }
    case 'LECTURE':
      return {
        status: 'Lecture',
        bgColor: 'rgb(141 106 160 / 20%)',
        borderColor: '#8D6AA0',
        color: '#000000',
      }
    case 'WEBINAR':
      return {
        status: 'Webinar',
        bgColor: 'rgba(255, 182, 193, 0.25)',
        borderColor: '#E1A7BA',
        color: '#000000',
      }
    case 'SEMINAR':
      return {
        status: 'Seminar',
        bgColor: 'rgba(181, 163, 247, 0.25)',
        borderColor: '#B5A3F7',
        color: '#000000',
      }
    case 'PRE_PLACEMENT_TALK':
      return {
        status: 'Pre Placement Talk',
        bgColor: 'rgb(151 202 219 / 20%)',
        borderColor: '#97CADB',
        color: '#000000',
      }
    case 'OTHERS':
      return {
        status: 'Others',
        borderColor: 'rgba(0, 27, 72, 1)',
        bgColor: 'rgba(0, 27, 72, 0.2)',
        color: '#ffffff',
      }
    default:
      return {
        color: '#000000',
        bgColor: '#F3F3F3',
        borderColor: '#00000045',
        status: status,
      }
  }
}

const Events = ({
  getEventsList,
  updateStudent,
  getEventDetailsById,
  registerEvent,
  getStudentData
}) => {
  const calenderView = 'right'
  const listView = 'left'

  const { studentDetails } = useSelector(state => state?.studentData)

  const studentId = studentDetails?.id
  const instituteCampusId = studentDetails?.instituteCampusId
  const [currentWeekStart, setCurrentWeekStart] = useState(
    startOfWeek(new Date(), { weekStartsOn: 1 })
  )
  const [currentWeekEnd, setCurrentWeekEnd] = useState(getAdjustedDate)

  const [showMiniCalendar, setShowMiniCalendar] = useState(false)
  const today = format(new Date(), 'yyyy-MM-dd')
  const [listDate, setListDate] = useState(today)
  const formattedListDate = formatDateWithOrdinal(new Date(listDate))
  const [fromDate, setFromDate] = useState(null)
  const [selectedCategory, setSelectedCategory] = useState([])
  const calendarRef = useRef(null)
  const menuRef = useRef(null)
  const [calenderData, setCalenderData] = useState([])

  const [state, setState] = useState({
    pageNo: 0,
    pageLimit: 50,
    from: listDate,
    category: '',
    occurence: 'UPCOMING',
    forCalendar: false,
    forRegisterEvent: false,
    status: '',
    search: '',
    selectedCategory: [],
    eventsList: [],
    eventListCurrentObj: null,
    dateList: [listDate],
    sort: '',
    loading: false,
    hasMoreData: true,
    forRecentlyAdded: false,
    previewClose: false,
    selectedEvent: [],
    selectedEventCategory: '',
    stdDetailsDrawerOpen: false,
    currentToggle: listView,
    sortBy: 'showAll',
  })

  const getAdjustedDate = () => {
    const today = new Date()
    if (state.currentToggle === listView) {
      return today
    } else {
      return endOfWeek(today, { weekStartsOn: 1 })
    }
  }

  //External Event
  const [eventApplyModal, setEventApplyModal] = useState(false)
  const [eventApplyTitle, setEventApplyTitle] = useState('')
  const [registrationSuccessModal, setRegistrationSuccessModal] =
    useState(false)

  const onEventModalClose = async () => {
    setEventApplyModal(false)
    setEventApplyTitle('')
    await updateStudent({ lastAppliedEventIds: [] })
  }

  const onEventAccept = async () => {
    setEventApplyModal(false)
    setEventApplyTitle('')
    await toRegisterEvent(
      state?.selectedEvent?.id || studentDetails?.lastAppliedEventIds[0]
    )
    await updateStudent({ lastAppliedEventIds: [] })
  }

  const onCloseClick = () => {
    setRegistrationSuccessModal(false)
  }

  const handleOccurrenceClick = async occurrence => {
    const newDate =
      occurrence == 'UPCOMING'
        ? addDays(new Date(today), 0)
        : subDays(new Date(today), 1)
    const formattedNewDate = format(newDate, 'yyyy-MM-dd')
    setListDate(formattedNewDate)
    setState(prev => ({
      ...prev,
      occurence: occurrence,
      hasMoreData: true,
      pageNo: 0,
    }))
    fetchEventsList({
      occurence: occurrence,
      pageNo: 0,
      loadMore: false,
      from: formattedNewDate,
    })
  }

  const fetchEventDetailsById = async id => {
    try {
      const response = await getEventDetailsById(id, studentId)
      if (response?.data?.message == 'Success') {
        return response?.data?.data
      } else {
        return false
      }
    } catch (err) {
      //
    }
  }

  const handleSingleEventClick = async data => {
    if (data) {
      const response = await fetchEventDetailsById(data?.id)
      if (response) {
        setState(prev => ({
          ...prev,
          previewClose: true,
          selectedEventCategory: data?.category,
          selectedEvent: response,
        }))
      }
    }
  }

  const toRegisterEvent = async id => {
    try {
      let payLoad = {
        eventId: id,
        isApplied: 1,
      }
      let requestPayload = {
        studentId: studentId,
        instituteCampusId: instituteCampusId,
        payLoad: payLoad,
      }
      const response = await registerEvent(requestPayload)
      if (response?.data?.message == 'Success') {
        fetchEventsList({ 
          forCalendar: state.currentToggle !== 'left',
          pageNo: 0 })
        if (state?.stdDetailsDrawerOpen) {
          setRegistrationSuccessModal(true)
        }
        setState(prev => ({
          ...prev,
          currentToggle:state.currentToggle,
          previewClose: false,
          stdDetailsDrawerOpen: false,
          hasMoreData: true,
          pageNo: 0,
        }))
      }
    } catch {
      //
    }
  }

  const handleRegistrationClick = async data => {
    if (data?.registrationLink) {
      window.open(data?.registrationLink, '_blank')
      await updateStudent({ lastAppliedEventIds: [data?.id] })
      setEventApplyModal(true)
      setEventApplyTitle(data?.title)
      setState(prev => ({
        ...prev,
        previewClose: false,
      }))
    } else {
      handleNoRegistrationLink(data);
     
    }
  }
  async function handleNoRegistrationLink(data) {
    if (state?.stdDetailsDrawerOpen) {
      await toRegisterEvent(data?.id);
    } else {
      setState(prev => ({
        ...prev,
        previewClose: false,
        stdDetailsDrawerOpen: true,
      }));
    }
  }
  useEffect(() => {
    getStudentData()
  }, [])

  const fetchEventsList = async ({
    pageNo = state.pageNo,
    pageLimit = state.pageLimit,
    from = state.from,
    category = state.selectedCategory,
    occurence = state.occurence,
    forCalendar = state.forCalendar,
    forRegisterEvent = state.forRegisterEvent,
    status = state.status,
    search = state.search,
    loadMore = false,
    sort = state?.sort,
    forRecentlyAdded = state?.forRecentlyAdded,
  } = {}) => {
    try {
      let payload = {
        studentId: studentId,
        instituteCampusId: instituteCampusId,
        pageNo: pageNo,
        pageLimit: pageLimit,
        from: from,
        category: category,
        occurence: occurence,
        forCalendar: forCalendar,
        forRegisterEvent: forRegisterEvent,
        status: status,
        search: search,
        sort: sort,
        forRecentlyAdded: forRecentlyAdded,
      }
      setState(prev => ({
        ...prev,
        loading: !loadMore,
      }))
      const response = await getEventsList(payload)
      if (response?.data?.message === 'Success') {
        const eventListCurrentObj = response?.data?.data
        const newEvents = response?.data?.data?.result
        setCalenderData(newEvents)
        if (eventListCurrentObj && Array.isArray(newEvents)) {
          const list = loadMore
            ? [...(state?.eventsList || []), ...newEvents]
            : [...newEvents]
            const fullList = list.map(event => ({
              ...event,
              startDate1: event.startDate ,
              endDate1: event.endDate,
              registerEndDate1: event?.registerEndDate
            }));
            const expandedList = fullList.flatMap(event => {
              const start = event?.isRegister && event?.studentEventMapping?.length === 0
                ? event?.registerStartDate?.split('T')[0]
                : event?.startDate?.split('T')[0];
              const end = event?.isRegister && event?.studentEventMapping?.length === 0
                ? event?.registerEndDate?.split('T')[0]
                : event?.endDate?.split('T')[0];
            
              if (start !== end) {
                return splitMultiDayEvent(event);
              }
              if(start === end && event?.isRegister && event?.studentEventMapping?.length === 0)
              {
                return {
                  ...event,
                  startDate: event?.registerStartDate
                };
              }
              return event;
            });
            
          const groupedEvents = expandedList.reduce((acc, event) => {
            const eventDate =   format(new Date(event.startDate), 'yyyy-MM-dd')
            if (!acc[eventDate]) {
              acc[eventDate] = []
            }
            acc[eventDate].push(event)
            return acc
          }, {})
          for (const date in groupedEvents) {
            groupedEvents[date].sort((a, b) => {
              // If both are all-day events or both are not all-day events, maintain order
              if (a.allDayEvent === b.allDayEvent) {
                return 0;
              }
              // If a is all-day and b is not, a comes first
              if (a.allDayEvent) {
                return -1;
              }
              // If b is all-day and a is not, b comes first
              return 1;
            });
          }
          const eventList = forRecentlyAdded ? 
          [{
              date: 'noDate', eventsList: fullList
            }] :
          filterEventsByOccurrence(groupedEvents, occurence, from);
          
          // Object.entries(groupedEvents).map(
          //   ([date, events]) => ({ date: date, eventsList: events })
          // )
          setState(prevState => ({
            ...prevState,
            eventListCurrentObj,
            eventsList: list,
            eventFullList: eventList,
          }))
        }
      }
      return response?.data?.data
    } catch (error) {
      console.error('Error fetching events:', error)
    } finally {
      setTimeout(() => {
        setState(prev => ({
          ...prev,
          loading: false,
        }))
      }, 1000)
    }
  }

  const filterEventsByOccurrence = (groupedEvents, occurrence, currentDate) => {
    const comparisonDate = new Date(currentDate);
  
    return Object.entries(groupedEvents)
      .filter(([date, events]) => {
        const eventDate = new Date(date);
        if (occurrence === 'UPCOMING') {
          return eventDate >= comparisonDate; // Include current and future dates
        } else if (occurrence === 'PAST') {
          return eventDate <= comparisonDate; // Include only past dates
        }
        return true; // Default case, if occurrence is neither UPCOMING nor PAST
      })
      .sort(([dateA], [dateB]) => {
        const eventDateA = new Date(dateA);
        const eventDateB = new Date(dateB);
        if (occurrence === 'UPCOMING') {
          return eventDateA - eventDateB; // Sort in ascending order for upcoming events
        } else if (occurrence === 'PAST') {
          return eventDateB - eventDateA; // Sort in descending order for past events
        }
        return 0;
      })
      .map(([date, events]) => ({ date: date, eventsList: events }));
  };
  const splitMultiDayEvent = event => {
    const start = event?.isRegister && event?.studentEventMapping?.length === 0
      ? new Date(event.registerStartDate)
      : new Date(event.startDate);
    const end = event?.isRegister && event?.studentEventMapping?.length === 0
      ? new Date(event.registerEndDate)
      : new Date(event.endDate);
      const startDateOnly = new Date(start.toISOString().split('T')[0]);
      const endDateOnly = new Date(end.toISOString().split('T')[0]);
      const days = Math.ceil((endDateOnly - startDateOnly) / (1000 * 60 * 60 * 24)) + 1;
      const eventDays = [];
    
      for (let i = 0; i < days; i++) {
        const currentDate = new Date(startDateOnly.getTime() + i * (1000 * 60 * 60 * 24));
        const eventDay = {
          ...event,
          startDate: currentDate.toISOString(),
          endDate: currentDate.toISOString(),
        };
    
        if (i === 0) {
          eventDay.startDate = start.toISOString();
        }
        if (i === days - 1) {
          eventDay.endDate = end.toISOString();
        }
    
        eventDays.push(eventDay);
      }
    
      return eventDays;
  };
  useEffect(() => {
    fetchEventsList()
  }, [])

  const fetchSearchedEvents = useCallback(
    Debounce(searchTerm => {
      fetchEventsList({ pageNo: 0, search: searchTerm, from: listDate })
    }, 1000),
    [state.pageNo, listDate]
  )

  const handleSearch = data => {
    setState(prev => ({
      ...prev,
      search: data,
      hasMoreData: true,
      pageNo: 0,
      currentToggle: 'left',
    }))
    fetchSearchedEvents(data)
  }

  useEffect(() => {
    setCurrentWeekStart(startOfWeek(new Date(), { weekStartsOn: 1 }))
    setCurrentWeekEnd(endOfWeek(new Date(), { weekStartsOn: 1 }))
  }, [])

  useEffect(() => {
    if (fromDate != null) {
      const newStart = startOfWeek(new Date(fromDate), { weekStartsOn: 1 })
      const newEnd = endOfWeek(new Date(fromDate), { weekStartsOn: 1 })
      setCurrentWeekStart(newStart)
      setCurrentWeekEnd(newEnd)
      if (calendarRef?.current) {
        const calendarApi = calendarRef.current?.getApi()
        calendarApi.gotoDate(newStart)
      }
      setShowMiniCalendar(false)
    }
  }, [fromDate])

  useEffect(() => {
    const handleClickOutside = event => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMiniCalendar(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleCaptureChange = data => {
    let currentDate = new Date(today)
    let clickedDate = new Date(data)
    let occurence = clickedDate < currentDate ? 'PAST' : 'UPCOMING'
    fetchEventsList({ from: data, pageNo: 0, occurence: occurence })
    setState(prev => ({
      ...prev,
      occurence: occurence,
      hasMoreData: true,
    }))
    setShowMiniCalendar(false)
  }

  const menu = (
    <MiniCalWidth ref={menuRef}>
      <CalenderStyled
        setFromDate={
          state.currentToggle == listView ? setListDate : setFromDate
        }
        fromDate={state.currentToggle == listView ? listDate : fromDate}
        listView={state.currentToggle == listView}
        handleCaptureChange={handleCaptureChange}
      />
    </MiniCalWidth>
  )

  const handlePrevWeek = () => {
    if (state.currentToggle === calenderView) {
      const newStart = subWeeks(currentWeekStart, 1)
      const newEnd = subWeeks(currentWeekEnd, 1)
      setCurrentWeekStart(newStart)
      setCurrentWeekEnd(newEnd)
      const calendarApi = calendarRef.current.getApi()
      calendarApi.gotoDate(newStart)
    } else {
      const newDate = subDays(new Date(listDate), 1)
      const formattedNewDate = format(newDate, 'yyyy-MM-dd')
      setListDate(formattedNewDate)
      let currentDate = new Date(today)
      let clickedDate = new Date(formattedNewDate)
      let occurence = clickedDate < currentDate ? 'PAST' : 'UPCOMING'
      fetchEventsList({
        from: formattedNewDate,
        pageNo: 0,
        loadMore: false,
        occurence: occurence,
      })
      setState(prev => ({
        ...prev,
        pageNo: 0,
        hasMoreData: true,
        occurence: occurence,
      }))
    }
  }

  const handleNextWeek = () => {
    if (state.currentToggle === calenderView) {
      const newStart = addWeeks(currentWeekStart, 1)
      const newEnd = addWeeks(currentWeekEnd, 1)
      setCurrentWeekStart(newStart)
      setCurrentWeekEnd(newEnd)
      const calendarApi = calendarRef.current.getApi()
      calendarApi.gotoDate(newStart)
    } else {
      const newDate = addDays(new Date(listDate), 1)
      const formattedNewDate = format(newDate, 'yyyy-MM-dd')
      setListDate(formattedNewDate)
      let currentDate = new Date(today)
      let clickedDate = new Date(formattedNewDate)
      let occurence = clickedDate >= currentDate ? 'UPCOMING' : 'PAST'
      fetchEventsList({
        from: formattedNewDate,
        pageNo: 0,
        loadMore: false,
        occurence: occurence,
      })
      setState(prev => ({
        ...prev,
        pageNo: 0,
        hasMoreData: true,
        occurence: occurence,
      }))
    }
  }

  const toggleMiniCalendar = () => {
    setShowMiniCalendar(!showMiniCalendar)
  }

  const handleCategoryChange = (value, label, extra) => {
    let selectedItem = []
    const selectedNodeProps = extra.triggerNode.props
    if (selectedNodeProps?.value == 'showAll') {
      selectedItem = selectedNodeProps?.children?.map(item => item.props?.value)
    } else {
      selectedItem = value?.map(item => item.value)
    }
    const selectedCat = selectedItem?.join(',')
    setState(prev => ({
      ...prev,
      selectedCategory: selectedCat,
      hasMoreData: true,
      currentToggle: listView,
      pageNo: 0,
    }))
    setSelectedCategory(value)
    fetchEventsList({ category: selectedCat, pageNo: 0, forCalendar: false })
  }

  const handleSortByChange = async value => {
    setState(prev => ({
      ...prev,
      forRecentlyAdded: value == 'forRecentlyAdded',
      forRegisterEvent: value == 'forRegisterEvent',
      sortBy: value,
      hasMoreData: true,
    }))
    fetchEventsList({
      pageNo: 0,
      forRecentlyAdded: value == 'forRecentlyAdded',
      forRegisterEvent: value == 'forRegisterEvent',
    })
  }

  const handleToggleChange = data => {
    setListDate(today)
    setState(prev => ({
      ...prev,
      search:'',
      currentToggle: data,
      pageNo: 0,
      occurence: 'UPCOMING',
      hasMoreData: true,
    }))
    fetchEventsList({
      search:'',
      forCalendar: data !== listView,
      pageNo: 0,
      occurence: 'UPCOMING',
      from: today,
    })
  }

  const registrationContent = () => {
    return (
        <div
          style={{
            padding: '2rem',
            height: '100%',
            paddingBottom: '0px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Row style={{ gap: '2rem' }}>
            <Col span={24}>
              <DynamicText>Name</DynamicText>
              <DynamicText fontWeight={700} size={'16px'}>
              {(studentDetails?.firstName ?? '') + ' ' + (studentDetails?.lastName ?? '')}

              </DynamicText>
            </Col>
            <Col span={24}>
              <DynamicText>Contact details</DynamicText>
              {studentDetails?.studentPersonalProfile?.phoneNumber ? (
                <DynamicText fontWeight={700} size={'16px'}>
                  {studentDetails?.studentPersonalProfile?.phoneNumber}
                </DynamicText>
              ) : null}
              <DynamicText fontWeight={700} size={'16px'}>
                {studentDetails?.studentPersonalProfile?.primaryEmail}
              </DynamicText>
            </Col>
            <Col span={24}>
              <DynamicText>Degree & Department</DynamicText>
              <DynamicText fontWeight={700} size={'16px'}>
                {studentDetails?.currentCourse?.degree}
                {' - '}
                {studentDetails?.currentCourse?.department}
              </DynamicText>
            </Col>
          </Row>
          <Row style={{ display: 'flex', alignItems: 'flex-end', flex: 1 }}>
            <Col>* These details will be sent for registration</Col>
          </Row>
        </div>
    )
  }

  const onClose = () => {
    setState(prev => ({
      ...prev,
      previewClose: false,
      //  selectedEvent: [],
      selectedEventCategory: '',
      stdDetailsDrawerOpen: false,
      hasMoreData: true,
    }))
  }

  const registrationFooter = () => {
    return (
      <Row style={{ justifyContent: 'flex-end', gap: '2rem' }}>
        <StatusButton
          mLeft={'unset'}
          text={'Cancel'}
          status={'cancel'}
          onClick={onClose}
        />
        <StatusButton
          text={'Register'}
          status={'register'}
          onClick={() => handleRegistrationClick(state?.selectedEvent)}
          removeLeft={true}
          mLeft={'unset'}
          
        />
      </Row>
    )
  }

  const handleStudentDrawerClick = () => {
    window?.open(state?.selectedEvent?.onlineLink)
  }

  return (
      <MainWrapper column>
        <Header
          menu={menu}
          handlePrevWeek={handlePrevWeek}
          handleNextWeek={handleNextWeek}
          toggleMiniCalendar={toggleMiniCalendar}
          handleCategoryChange={handleCategoryChange}
          showMiniCalendar={showMiniCalendar}
          handleToggleChange={handleToggleChange}
          formattedListDate={formattedListDate}
          currentWeekStart={currentWeekStart}
          currentWeekEnd={currentWeekEnd}
          selectedCategory={selectedCategory}
          handleSearch={handleSearch}
          state={state}
        />

        <EventDetails
          currentWeekStart={currentWeekStart}
          currentWeekEnd={currentWeekEnd}
          calendarRef={calendarRef}
          currentToggle={state.currentToggle}
          state={state}
          handleOccurrenceClick={handleOccurrenceClick}
          setState={setState}
          fetchEventsList={fetchEventsList}
          setListDate={setListDate}
          listDate={listDate}
          handleSortByChange={handleSortByChange}
          handleSingleEventClick={handleSingleEventClick}
          handleRegistrationClick={handleRegistrationClick}
          studentDetails={studentDetails}
          calenderData={calenderData}
        />

        <EventPreview
          open={state.previewClose}
          header={true}
          onClose={onClose}
          // categoryBasedObj={categoryBasedStyle(state?.selectedEventCategory)}
          data={state?.selectedEvent || []}
          handleClick={handleStudentDrawerClick}
          handleRegistrationClick={handleRegistrationClick}
        />
        <Drawer
          width="600px"
          placement="right"
          padding="-30px"
          closable
          onClose={onClose}
          visible={state.stdDetailsDrawerOpen}
          content={registrationContent()}
          footer={registrationFooter()}
          title={'Registration'}
        />

        <SuccessModal
          open={registrationSuccessModal}
          message={'Registration done successfully!'}
          onCloseClick={onCloseClick}
        />

        <ConfirmationModal
          onCloseClick={() => onEventModalClose()}
          open={eventApplyModal}
          actionKey={'lastAppliedEventIds'}
          description={`Did you register for`}
          title={eventApplyTitle}
          onApplyClick={onEventAccept}
        />
      </MainWrapper>
  )
}
export default Events
